import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/vo2-max-calculator',
  component: () => import('../../routes/VO2MaxCalculator.svelte'),
  card: {
    id: 'vo2-max',
    title: 'VO2 Max',
    description: 'Estimate your maximum oxygen uptake using the Cooper, Rockport, or Leger beep test methods.',
    icon: 'directions_run',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/vo2-max-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'VO2 Max Calculator – Cooper, Rockport & Leger Test Methods',
    description:
      'Free VO2 max calculator estimates your cardiovascular fitness using the Cooper 1.5-mile run, Rockport 1-mile walk, or Leger 20m shuttle run test. Get your fitness rating instantly.',
  },
};

export default meta;
